import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7da53938")
const _hoisted_1 = { id: "wrapper" }
const _hoisted_2 = { class: "x" }
const _hoisted_3 = { class: "y" }
const _hoisted_4 = { id: "cursor" }
const _hoisted_5 = {
  key: 1,
  class: "_img"
}
const _hoisted_6 = { class: "page" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "brand" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "logo",
    class: "_img"
  }),
  /*#__PURE__*/_createElementVNode("div", null, "gochase.me")
], -1)
const _hoisted_8 = {
  key: 0,
  id: "loginButton",
  class: "but"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Please wait ")
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Hi, Josh!", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "Let's get started", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_16 = { class: "but" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Host a game ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "page" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"page\" data-v-7da53938><div class=\"game\" data-v-7da53938><div class=\"image _img\" style=\"background-image:url(https://s3.ap-southeast-1.amazonaws.com/gochaseme/72fb27ad-8b2f-4840-ba79-67a39b2899a1.jpeg);\" data-v-7da53938></div><div class=\"text\" data-v-7da53938><div class=\"title\" data-v-7da53938><h4 data-v-7da53938>An Unnatural Science</h4></div><div class=\"description\" data-v-7da53938> The untimely death of a feared professor leaves you to solve his murder and actualize his life&#39;s work. </div></div></div><div class=\"game\" data-v-7da53938><div class=\"image _img\" style=\"background-image:url(https://cdn.pixabay.com/photo/2021/10/28/00/26/mount-fuji-6748510_1280.jpg);\" data-v-7da53938></div><div class=\"text\" data-v-7da53938><div class=\"title\" data-v-7da53938><h4 data-v-7da53938>Thin Air</h4></div><div class=\"description\" data-v-7da53938> Exploring the hilltops is rarely bested, though perhaps when a discovery is hidden looming nearby. </div></div></div><div class=\"game\" data-v-7da53938><div class=\"image _img\" style=\"background-image:url(https://cdn.pixabay.com/photo/2019/12/04/17/21/daintree-4673212_1280.jpg);\" data-v-7da53938></div><div class=\"text\" data-v-7da53938><div class=\"title\" data-v-7da53938><h4 data-v-7da53938>A Pitter Patter</h4></div><div class=\"description\" data-v-7da53938> Vast nature engulfs you as the busy life of the city seems to melt away. There&#39;s something suspicious about the trail you&#39;ve found. </div></div></div><div class=\"game\" data-v-7da53938><div class=\"image _img\" style=\"background-image:url(https://live.staticflickr.com/28/67024557_fb5c026e11_b.jpg);\" data-v-7da53938></div><div class=\"text\" data-v-7da53938><div class=\"title\" data-v-7da53938><h4 data-v-7da53938>A Magma Cartel</h4></div><div class=\"description\" data-v-7da53938> Exploring the hilltops is rarely bested, though perhaps when a discovery is hidden looming nearby. </div></div></div><div class=\"advisory\" data-v-7da53938><h4 data-v-7da53938>Advisory</h4> Game purchase states are managed through login states. Switching between accounts will not carry game purchases over. Our games are created in English. </div></div>", 1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "page" }
const _hoisted_22 = {
  key: 0,
  id: "lobbyLoader"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", null, "Loading lobby", -1)
const _hoisted_24 = {
  key: 1,
  class: "lobby"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "image _img",
  style: {"background-image":"url(https://cdn.pixabay.com/photo/2021/10/28/00/26/mount-fuji-6748510_1280.jpg)"}
}, null, -1)
const _hoisted_26 = { class: "text" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Thin Air")
], -1)
const _hoisted_28 = { class: "meta" }
const _hoisted_29 = { class: "rating" }
const _hoisted_30 = { class: "description" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h4", null, "Description", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Exploring the hilltops is rarely bested, though perhaps when a discovery is hidden looming nearby. ")
const _hoisted_33 = { class: "but col cen" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Purchase")
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Purchasing ")
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Purchased ")
const _hoisted_39 = { class: "page" }
const _hoisted_40 = {
  key: 0,
  class: "tick"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h2", null, "Lobby created", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, "Your lobby code", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "user",
      class: _normalizeClass({
      enter:_ctx.stage>0 && _ctx.stage<12,
      click:_ctx.stage==2||_ctx.stage==4||_ctx.stage==5||_ctx.stage==7||_ctx.stage==11,
      picture:_ctx.stage>2,
      openHost:_ctx.stage>3,
      scroll:_ctx.stage==5,
      select:_ctx.stage>5, 
      lobby:_ctx.stage>7,
      scrollTwo:_ctx.stage==9,
      purchase:_ctx.stage==10,
    })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.stage==2)
              ? (_openBlock(), _createBlock(_component_MovingIcon, {
                  key: 0,
                  name: "loader_spinner",
                  autoplay: true,
                  loop: true
                }))
              : (_ctx.stage>2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      id: "screen",
      class: _normalizeClass({
      first:true,
      visible:_ctx.stage>-1,
      shrink:_ctx.stage>3,
      shrink2:_ctx.stage>6,
      shrink3:_ctx.stage>11,
    })
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          id: "loginSection",
          class: _normalizeClass({large:_ctx.stage>2})
        }, [
          _hoisted_7,
          (_ctx.stage<3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.stage<2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_9
                    ], 64))
                  : (_ctx.stage==2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_MovingIcon, {
                          name: "loader_spinner",
                          autoplay: true,
                          loop: true
                        }),
                        _hoisted_11
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_MovingIcon, {
                      name: "forward",
                      autoplay: true,
                      loop: true
                    }),
                    _hoisted_17
                  ])
                ])
              ]))
        ], 2)
      ]),
      _hoisted_18
    ], 2),
    _createElementVNode("div", {
      id: "screen",
      class: _normalizeClass({
      visible:_ctx.stage>3,
      second:true,
      scroll:_ctx.stage>4,
      shrink:_ctx.stage>6,
      shrink2:_ctx.stage>11,
    })
    }, _hoisted_20, 2),
    _createElementVNode("div", {
      id: "screen",
      class: _normalizeClass({
      visible:_ctx.stage>6,
      third:true,
      scroll:_ctx.stage>8,
      shrink:_ctx.stage>11,
    })
    }, [
      _createElementVNode("div", _hoisted_21, [
        (_ctx.stage==7)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_MovingIcon, {
                name: "loader_spinner",
                autoplay: true,
                loop: true
              }),
              _hoisted_23
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_MovingIcon, {
                      name: "star_filled",
                      hex: "#000",
                      type: "svg"
                    }),
                    _createVNode(_component_MovingIcon, {
                      name: "star_filled",
                      hex: "#000",
                      type: "svg"
                    }),
                    _createVNode(_component_MovingIcon, {
                      name: "star_filled",
                      hex: "#000",
                      type: "svg"
                    }),
                    _createVNode(_component_MovingIcon, {
                      name: "star_filled",
                      hex: "#000",
                      type: "svg"
                    }),
                    _createVNode(_component_MovingIcon, {
                      name: "star",
                      hex: "#a0a0a0",
                      type: "svg"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", null, [
                    _hoisted_31,
                    _createVNode(_component_MovingIcon, {
                      name: "chevron_down",
                      type: "lottie"
                    })
                  ]),
                  _hoisted_32
                ]),
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.stage<11)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_34
                      ], 64))
                    : (_ctx.stage<12)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createVNode(_component_MovingIcon, {
                            name: "loader_spinner",
                            hex: "#FFF",
                            autoplay: true,
                            loop: true
                          }),
                          _hoisted_36
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createVNode(_component_MovingIcon, {
                            name: "tick",
                            hex: "#FFF",
                            autoplay: true
                          }),
                          _hoisted_38
                        ]))
                ])
              ])
            ]))
      ])
    ], 2),
    _createElementVNode("div", {
      id: "screen",
      class: _normalizeClass({
      visible:_ctx.stage>11,
      fourth:true,
    })
    }, [
      _createElementVNode("div", _hoisted_39, [
        (_ctx.stage>11)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createVNode(_component_MovingIcon, {
                name: "tick",
                hex: "#fff",
                autoplay: true
              })
            ]))
          : _createCommentVNode("", true),
        _hoisted_41,
        _hoisted_42,
        _hoisted_43,
        _hoisted_44,
        _createElementVNode("h2", null, _toDisplayString(_ctx.lobbyCode), 1)
      ])
    ], 2)
  ]))
}